import { render, staticRenderFns } from "./RatingPage.vue?vue&type=template&id=7a4d5708&"
import script from "./RatingPage.vue?vue&type=script&lang=js&"
export * from "./RatingPage.vue?vue&type=script&lang=js&"
import style0 from "./RatingPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports